import { useWelcomePage } from "./logic";
import { WelcomePageTemplate } from "./template";

export const WelcomePage = (): JSX.Element => {
  const data = useWelcomePage();
  return <WelcomePageTemplate {...data} />;
};
